import Button from 'components/Button'
import TextTitleCondensed from 'components/TextTitleCondensed'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

class ProductQuantity extends React.Component {
  static propTypes = {
    value: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick () {
    this.props.onClick(this.props.value)
  }

  render () {
    const { value } = this.props
    let style = {
      padding: `${STYLES_PADDING.SMALL}`
    }
    if (this.props.isSelected) {
      style = {
        ...style,
        color: STYLES_COLOR.WHITE,
        backgroundColor: STYLES_COLOR.BLACK
      }
    }
    return (
      <Button
        isDisabled={getValueReduxUtil(value, 'value') <= 0}
        onClick={this.handleClick}
        style={style}
        height='auto'
      >
        <TextTitleCondensed>
          {getValueReduxUtil(value, 'name').toUpperCase()}
        </TextTitleCondensed>
      </Button>
    )
  }
}

export default ProductQuantity
